import ReactDOM from "react-dom";
import Styles from "./Loader.module.css";
import loaderImg from "../../Assets/kstore_loader.gif";

export default function Loader(props) {
  if (!props.isLoader) return null;

  const content = (
    <div className={Styles.loaderParent}>
      <img className={Styles.loadergif} src={loaderImg} alt="loader" />
    </div>
  );

  return typeof document !== "undefined"
    ? ReactDOM.createPortal(content, document.body)
    : content;
}
